import React, { Component } from 'react';
import '../css_generales/getLogin.css';
import 'whatwg-fetch';

class getLogin extends Component {
  constructor(){
    super();
    this.state = {
        usuario:'',
        contrasenia:'',
        agente:'',
        msg:'',
        recordar:false   // ⬅️ agregado
    }
  }

  componentDidMount(){
    // ⬅️ cargar datos recordados
    const usu = localStorage.getItem("login_usuario");
    const pass = localStorage.getItem("login_contrasenia");
    const rec = localStorage.getItem("login_recordar");
    //const agente = localStorage.getItem("login_recordar");

    if(rec === "true"){
        this.setState({
          usuario: usu || "",
          contrasenia: pass || "",
          recordar: true
        })
      }
    }

  getValite =()=>{

    const usuario = this.state.usuario.trim()
    const password = this.state.contrasenia.trim()
    const agente = this.state.agente.trim()

    if(usuario.trim()===''){
      this.setState({
        msg : "Ingrese Usuario"
      })
      return
    }
    if(password.trim()===''){
      this.setState({
        msg : "Ingrese Contraseña"
      })
      return
    }

    // ⬅️ Guardar o borrar según el checkbox
    if(this.state.recordar){
      localStorage.setItem("login_usuario", usuario);
      localStorage.setItem("login_contrasenia", password);
      localStorage.setItem("login_recordar", "true");
    }else{
      localStorage.removeItem("login_usuario");
      localStorage.removeItem("login_contrasenia");
      localStorage.setItem("login_recordar", "false");
    }

    const url= this.props.dir_url + "webapp/getValite_U_User";
    const token =  this.props.token

    var obj = { accion:'validateU', token, usuario, password,agente};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.props.setTokenusuario(data[0].msg[0].uuid_usuario,data[0].msg[0].uuid_agente,data[0].msg[0].agente_nombre)
      }else{
        this.setState({
          msg : "Usuario o Contraseña incorrecta"
        })
      }
      this.props.get_loading(false)
    })
    .catch(console.log)
   this.props.get_loading(true)
  }


  inputChangedHandlerText2 = (event) => {
    this.setState({
      usuario :event.target.value
    })
  }

  inputChangedHandlerText3 = (event) => {
    this.setState({
      contrasenia :event.target.value
    })
  }

  inputChangedHandlerText4 = (event) => {
    this.setState({
      agente :event.target.value
    })
  }
  // ⬅️ manejar checkbox
  toggleRecordar = () => {
    this.setState({ recordar: !this.state.recordar });
  }

  render() {

    let logo
    const uuid_imagen=((this.props.uuid_imagen)+"").trim()
    const url_image = this.props.url_image
    const separator = this.props.separator
    const file_xxx =this.props.file_250x200
    const token_image = url_image+file_xxx+separator
    const ext="_250x200.png?alt=media"
    if(uuid_imagen===''){
      logo="https://www.grupmn.net/app/img/sinfoto.png"
    }else{
      logo=token_image+uuid_imagen+ext
    }
    return (

      <div className="cssversion_menu cssversion_colorblanco">
        <div className="cssversion_pw100 cssversion_pxh110" style={{"display":"flex"}}>
          <div className="cssversion_pw100 cssversion_pxh110 cssversion_contentCenter">
            <img className="cssversion_pxw150" alt="Cargando Imagen . . ." src={logo} />
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_pxh100 cssversion_contentCenter" style={{"display":"flex"}}>
          <span className="span-global-title">Iniciar Sesión</span>
        </div>
        <div className="cssversion_pw100">
          <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
            <div className="cssversion_pw10 cssversion_pxh50 cssversion_contentCenter">
            </div>
            <div className="cssversion_pw20 cssversion_pxh50 cssversion_contentCenter">
               <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            </div>
            <div className="cssversion_pw60 cssversion_pxh50 cssversion_contentCenter">
                <input value={this.state.usuario} onChange={(event)=>this.inputChangedHandlerText2(event)} className="input-global cssversion_pw90" placeholder="Usuario" />
            </div>
            <div className="cssversion_pw10 cssversion_pxh50 cssversion_contentCenter">
            </div>
          </div>

          <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
            <div className="cssversion_pw10 cssversion_pxh50 cssversion_contentCenter">
            </div>
            <div className="cssversion_pw20 cssversion_pxh50 cssversion_contentCenter">
               <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/469704211582004494-128.png') } />
            </div>
            <div className="cssversion_pw60 cssversion_pxh50 cssversion_contentCenter">
                <input value={this.state.contrasenia}  type="password" onChange={(event)=>this.inputChangedHandlerText3(event)} className="input-global cssversion_pw90" placeholder="Contraseña" />
            </div>
            <div className="cssversion_pw10 cssversion_pxh50 cssversion_contentCenter">
            </div>
          </div>

           <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}>
            <div className="cssversion_pw10 cssversion_pxh50 cssversion_contentCenter">
            </div>
            <div className="cssversion_pw20 cssversion_pxh50 cssversion_contentCenter">
               <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') } />
            </div>
            <div className="cssversion_pw60 cssversion_pxh50 cssversion_contentCenter">
                <input value={this.state.agente} onChange={(event)=>this.inputChangedHandlerText4(event)} className="input-global cssversion_pw90" placeholder="Código Agente" />
            </div>
            <div className="cssversion_pw10 cssversion_pxh50 cssversion_contentCenter">
            </div>
          </div>

          {/*  ⬅️ CHECKBOX RECORDAR  */}
          <div className="cssversion_pw100 cssversion_pxh40 cssversion_contentCenter" style={{display:"flex"}}>
              <input 
                type="checkbox" 
                checked={this.state.recordar}
                onChange={this.toggleRecordar}
                style={{marginRight:"10px"}}
              />
              <span className="span-global-link">Recordar mis datos</span>
          </div>

          <div className="cssversion_pw100 cssversion_pxh100 cssversion_contentCenter">
              <button className="button-global cssversion_pw85" onClick={ () => this.getValite()}>
                Validar Clave
              </button>
          </div>

          <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter">
            {(this.state.msg)?
            <div className="cssversion_pw85 cssversion_pxh40 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#f44336","borderRadius": "15px"}}>
              <span className="span-global-link" style={{"color":"white"}}>{this.state.msg}</span>
            </div>
            :''}
          </div>
        </div>
      </div>

    );
  }

}

export default getLogin;
